import axios from "axios";
import qs from "querystring";

//Import auth token
import { auth, getUserToken } from "_firebase";
import config from "_firebase/firebaseconfig.json";

const VITE_DASHBOARD_API_URI = config.VITE_DASHBOARD_API_URI;

var api = axios.create({
    baseURL: VITE_DASHBOARD_API_URI,
    timeout: 9 * 60000,
    withCredentials: true,
});

const IGNORE_URL_LIST = ["/resetPasswordLink", "/loginUser", "/checkSession", "/action-redirect", "/logoutUser"];

const request = (api) => {
    return async ({ url, data, method, headers, file, query, contentType, preStringified = false, ...rest }) => {
        const formatMethod = method ? method.toLowerCase() : "get";
        const token = IGNORE_URL_LIST.includes(url) ? "" : await getUserToken();
        const queryString = query ? `?${qs.stringify(query)}` : "";

        const dataToSend = preStringified ? data : JSON.stringify(data);

        return api({
            method: formatMethod,
            url: url + queryString,
            data: file ? file : dataToSend,
            headers: {
                Authorization: token ? `Bearer ${token}` : "",
                "content-type": contentType ? contentType : "application/json",
                ...headers,
            },
            ...rest,
        })
            .then((data) => {
                return data;
            })
            .catch((err) => {
                console.log("error inside request", JSON.stringify(err.message));
                return err;
            });
    };
};

export async function DashboardStream({ url, method = "GET", query, headers = {}, signal, body, ...rest }) {
    const token = await getUserToken();
    const q = query ? `?${qs.stringify(query)}` : "";

    const defaultHeaders = {
        Authorization: token ? `Bearer ${token}` : "",
        Accept: "application/x-ndjson",
    };

    if (method !== "GET" && body && !("Content-Type" in headers)) {
        defaultHeaders["Content-Type"] = "application/json";
        if (typeof body !== "string" && !(body instanceof FormData) && !(body instanceof Blob)) {
            body = JSON.stringify(body);
        }
    }

    const resp = await fetch(`${VITE_DASHBOARD_API_URI}${url}${q}`, {
        method,
        signal,
        body,
        ...rest,
        headers: { ...defaultHeaders, ...headers },
    });

    if (!resp.ok) throw new Error(`HTTP ${resp.status} for ${url}`);
    return resp; // native Response with .body ReadableStream
}

export async function readNdjson(response, { onLine }) {
    if (!response.body) throw new Error("No response body");
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buf = "";
    while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        buf += decoder.decode(value, { stream: true });
        let nl;
        while ((nl = buf.indexOf("\n")) >= 0) {
            const line = buf.slice(0, nl);
            buf = buf.slice(nl + 1);
            if (line.trim()) onLine(JSON.parse(line));
        }
    }
    if (buf.trim()) onLine(JSON.parse(buf));
}

const DashboardAPI = request(api);

// "request" resolves with the axios error instead of throwing, so a failed call arrives with its
// status and body one level down. This flattens both shapes and digs out whatever the server said.
export const readApiResponse = (response) => {
    const { status, data, response: errorResponse } = response || {};
    const body = (data ?? errorResponse?.data) || {};

    return {
        status: status ?? errorResponse?.status ?? 0,
        data: body,
        message: body?.err?.message || body?.message || response?.message || "",
    };
};

export { DashboardAPI, request };
